<template>
  <b-tab
    id="tab3"
    title="เพิ่มเรื่องร้องทุกข์"
  >
    <b-row>
      <b-col cols="12">
        <SearchFilter mode="List" />
      </b-col>
      <b-col cols="12">
        <common-table />
      </b-col>

      <b-col
        cols="12"
        class="d-flex justify-content-center"
      >
        <b-button variant="primary">
          เลือกข้อมูล
        </b-button>
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>

import {
  BRow, BCol, BFormTextarea, BFormGroup, BFormInput, BTab, BTabs, BCard, BButton,
} from 'bootstrap-vue'
import CommonTable from './ComplaintSelectTable.vue'
import SearchFilter from '../components/SearchFilter.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BButton,
    CommonTable,
    SearchFilter,
  },
}
</script>

<style>

</style>
